module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-vector-e997dd4d07a6859d9a9f9c40f6140b57.jpg";